import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { apiCall } from '@savgroup-front-common/core/services';

export default function getUser() {
  return apiCall(`${APIConfiguration.authorization}user`, {
    method: SUPPORTED_METHODS.GET,
  });
}
